﻿import { IGOMAveragesSetStation } from "../API/GOMAverages/GOMAveragesSet";
import { LiveDataSetValue, Status } from "../API/LiveData/LiveDataSet";
import { DefaultParameterDefinitions } from "../DefaultParameterDefinitions";
import { MainSite } from "../MainSite";
import { WarningGroup } from "../Model/WarningGroup";
import { ParameterGroupInfo, ParameterGroupInfoSet } from "../ParameterGroupInfoSet";
import { DefaultGroupFormatter } from "./DefaultGroupFormatter";
import { IStationValueObject } from "./IStationValueFormatter";

declare var sprintf;

export class GOMAveragesGroupFormatter extends DefaultGroupFormatter {

    constructor(
        protected parameterGroup: ParameterGroupInfo,
        private timeRange: string,
        //protected sensorId: string = undefined,
    ) {
        super(parameterGroup);
    }

    protected getGOMAveragesSetValue(GOMAveragesSetStation: IGOMAveragesSetStation): LiveDataSetValue {

        var value: LiveDataSetValue = null;

        //console.log('')
        //console.log('liveDataSetStation.GroupValues:', liveDataSetStation.GroupValues)
        //console.log('this.parameterGroup.Id', this.parameterGroup.Id)
        //console.log('liveDataSetStation.GroupValues', liveDataSetStation.GroupValues)
        //console.log('this.sensorId', this.sensorId)
        //console.log('')

        //if (GOMAveragesSetStation.GroupAverages && this.parameterGroup.Id in GOMAveragesSetStation.GroupAverages) {
        //    value = liveDataSetStation.GroupValues[this.parameterGroup.Id][0];
        //}

        const groupAverage = GOMAveragesSetStation.GroupAverages.filter(groupAverage => groupAverage.ParameterGroup == this.parameterGroup.Id)[0];

        // Filthy work-around because averaged values are not in the same format as latestValue
        if (groupAverage) {

            value = {
                ...groupAverage.LatestValue,
                Value: groupAverage[this.timeRange]
            }

        }

        return value;
    }
    
    //public format(
    public formatGOMAverages(
        GOMAveragesSetStation: IGOMAveragesSetStation,
        warningRules?: WarningGroup
    ): IStationValueObject {

        // the default if parameter has never existed
        var valueObject: IStationValueObject = {
            Value: '---',
            Status: null,
            WarningThreshold: null,
            ParameterDefinition: null,
            Sensor: null,
            Timestamp: null
        }

            const value = this.getGOMAveragesSetValue(GOMAveragesSetStation);

            if (value == null) {
                return valueObject;
            }

        // TODO: Does this make sense for groupAverages?
        //if (!MainSite.instance.staticDataManager.Schema.ParameterSchema.Stations[GOMAveragesSetStation.Station.Id].Sensors[value.Sensor]) {
        //    return valueObject;
        //}

        var paramDef = MainSite.instance.staticDataManager.Schema.ParameterSchema.Stations[GOMAveragesSetStation.Station.Id]
            .Sensors[value.Sensor]
            .Parameters[value.Parameter]
            .Variants[0]
            .ParameterDefinition;
        if ((!paramDef || paramDef.Default) && value.Parameter in DefaultParameterDefinitions.Parameters) {
            paramDef = DefaultParameterDefinitions.Parameters[value.Parameter];
        }

        // the default if parameter exists but has expired
        valueObject = {
            Value: '///',
            Status: value.ExpiryStatus,
            WarningThreshold: null,
            ParameterDefinition: paramDef,
            Timestamp: value.Timestamp,
            Sensor: value.Sensor
        }

        // Ignore (value.ExpiryStatus == Status.Expired) for averages
            if (value.Value === null) {
            return valueObject; // leave value as "///" if expired, don't bother checking warning rules
        }

        // console.info(`DefaultGroupFormatter.getConversionSet...`, this.parameterGroup.Units, this.parameterGroup);
        let unitsConversionSet = MainSite.getUnitConverter().getConversionSet(this.parameterGroup.Units, this.parameterGroup.Id);

        // TODO: Check with Ben that value.Value === null corresponds to expired.
        //if (value.Value === null || value.Value === 'NIL') {
        //    // can be the case for cloud heights, etc
        //    valueObject.Value = '';
        //} else
        if (typeof value.Value == 'number' && this.parameterGroup.Format) {
            // valueObject.Value = sprintf(this.parameterGroup.Format, MainSite.getUnitConverter().convert(value.Value, this.parameterGroup.Units, this.parameterGroup));
            if (unitsConversionSet) {
                if (this.parameterGroup == ParameterGroupInfoSet.Visibility_m) {
                    valueObject.Value = sprintf('%.2f', unitsConversionSet.convertValue(value.Value));
                } else {
                    valueObject.Value = sprintf(this.parameterGroup.Format, unitsConversionSet.convertValue(value.Value));
                }
            } else {
                valueObject.Value = sprintf(this.parameterGroup.Format, value.Value);
            }

            // TODO: FIX
            //if (warningRules) {
            //    valueObject.WarningThreshold = GetWarningThreshold(warningRules, value.Value, this.parameterGroup, GOMAveragesSetStation);
            //}
        } else {
            valueObject.Value = (MainSite.getUnitConverter().convert(value.Value, this.parameterGroup.Units, this.parameterGroup.Id)).toString();
        }

        return valueObject;
    }
}